import React from "react";
import { useSelector } from "react-redux";
import useCurrentPosition from "../../helpers/customHooks/useCurrentPosition";
import GoogleMapIFrame from "../common/GoogleMapIFrame";

function Info() {
  const restaurantInfo = useSelector((state) => state.restaurant.info);
  const { latitudeData, longitudeData } = useCurrentPosition();

  return (
    <>
      <div className="resturante-info">
        <h2 className="head6">Restaurant Address</h2>
        <div className="resturant-adress">
          <p>
            <b>Outlet Name</b>
            <span>{restaurantInfo?.outlet_name || "N/A"}</span>
          </p>
          <p>
            <b>Outlet Email</b>
            <span>{restaurantInfo?.email || "N/A"}</span>
          </p>
          <p>
            <b>Address Line 1</b>
            <span>{restaurantInfo?.addressLineOne || "N/A"}</span>
          </p>
          <p>
            <b>Address Line 2</b>
            <span>
              {restaurantInfo?.addressLineTwo &&
                restaurantInfo?.addressLineTwo === "null"
                ? ""
                : restaurantInfo?.addressLineTwo}
            </span>
          </p>
          <p>
            <b>Area</b>
            <span>{restaurantInfo?.area || "N/A"}</span>
          </p>
          <p>
            <b>City</b>
            <span>{restaurantInfo?.city || "N/A"}</span>
          </p>
          <p>
            <b>Street</b>
            <span>{restaurantInfo?.street || "N/A"}</span>
          </p>
          <p>
            <b>Zip Code</b>
            <span>{restaurantInfo?.zipcode || "N/A"}</span>
          </p>
          <p>
            <b>Contact Number</b>
            <span>{restaurantInfo?.contactNumber || "N/A"}</span>
          </p>
        </div>
        <GoogleMapIFrame
          latitudeData={latitudeData}
          longitudeData={longitudeData}
        />
      </div>
    </>
  );
}

export default Info;
